$shm_hitalama_benchmarks_page_metrics_details $mol_pick
	hint \Параметры компьютера и браузер
	trigger_content /
		<= Icon $mol_icon_information_outline
	Bubble $mol_pop_bubble
		content <= bubble_content
		height_max <= height_max
		style *
			^
			maxWidth <= popup_width_max 512
	bubble_content /
		<= Text $mol_view
			style *
				^
				maxWidth <= popup_width_max
			sub /
				<= Computer_label $mol_labeler
					title \Параметры компьютера
					content / <= Computer_value $mol_view
						sub / <= computer \
				<= Browser_label $mol_labeler
					title \Браузер
					content / <= Browser_value $mol_view
						sub / <= browser \
